export default __webpack_public_path__ + "static/media/Cord.c41c5325.png";